import React from 'react';
import styles from './CancelPaymentModal.module.css';

interface PopupModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancelPaymentModal: React.FC<PopupModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose()

    const urlObject = new URL(window.location.href);
    const origin = urlObject.origin;
    const pathname = urlObject.pathname;
    const newUrl = origin + pathname;

    window.location.href = newUrl;
  }

  return (
    <div className={styles.cancelModal}>
      <div className={styles.cancelModalContent}>
        <h2>Transaction Not Completed</h2>
        <p>It looks like the transaction was cancelled or did not go through. Please try again or contact support if you continue to experience issues.</p>
        <button onClick={handleClose}>Close</button>
      </div>
    </div>
  );
};

export default CancelPaymentModal;
